import React from 'react';
import DataTable from 'react-data-table-component';
import { useNavigate } from 'react-router-dom';
import { IconEdit, IconTrash, IconZoomIn, IconEye, IconArrowDown, IconArrowUp, IconEqual } from '@tabler/icons-react';
import { useNavigateWithSlugHook, } from "../../../../src/config/routes/guards/slug";
import { formatDate } from '../../../helpers/formatDate';

const DatatableRiskManagementMonitoringReport = (props) => {
  // console.log(props);

  const containerStyle = {
    whiteSpace: 'pre-wrap', // Ini yang paling penting
  };

  const navigate = useNavigateWithSlugHook();
  const handleChangePage = (path) => {
    navigate(path);
  };

  const columns = [
    {
      name: 'Aksi',
      minWidth: '150px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <button
            className="btn btn-sm btn-outline-danger"
            type="button"
            title="Edit Rencana Penanganan Risiko"
            onClick={() => props.handleEditRiskManagementMonitoringReport(row)}
          >
            <IconEdit stroke={2} />
          </button>
        </>
      ),
    },

    {
      name: 'Akar Masalah',
      minWidth: '300px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <div
          style={
            containerStyle
          }
        >
          {row?.risk_profile?.rootCause}
        </div>
      ),
    },
    {
      name: 'Aksi/Pengendalian',
      minWidth: '300px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <div style={
          containerStyle
        }>
          {row?.actionControl}
        </div>
      ),
    },
    // {
    //   name: 'Output Penanganan Risiko',
    //   minWidth: '300px', // Set a minimum width for horizontal scroll
    //   cell: (row) => (
    //     <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
    //       {row?.riskHandlingOutput}
    //     </div>
    //   ),
    //   style: {
    //     // You can also add more styles here
    //     whiteSpace: 'normal',
    //   },
    // },
    // {
    //   name: 'Target Penanganan Risiko',
    //   minWidth: '300px', // Set a minimum width for horizontal scroll
    //   cell: (row) => (
    //     <>
    //       <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
    //         {row?.riskHandlingTarget}
    //       </div>
    //     </>
    //   ),
    // },
    // {
    //   name: 'Realisasi Penanganan Risiko',
    //   minWidth: '300px', // Set a minimum width for horizontal scroll
    //   cell: (row) => (
    //     <>
    //       <div
    //         style={{
    //           whiteSpace: 'normal',
    //           wordWrap: 'break-word',
    //         }}
    //       >
    //         {row?.riskHandlingRealization}
    //       </div>
    //     </>
    //   ),
    // },
    {
      name: 'Waktu Pemantauan',
      minWidth: '200px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={{
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              textAlign: 'center',
              width: '100%',
            }}
          >
            {formatDate(row?.monitoringTime)}
          </div>
        </>
      ),
    },
    {
      name: 'Tingkat Risiko',
      minWidth: '150px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={{
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              textAlign: 'center',
              width: '100%',
            }}
          >
            {/* {row?.riskStatusLevel} */}
            {row.riskLevel === 'Sangat Rendah' ? (
              <span className="badge badge-primary text-black">
                Sangat Rendah
              </span>
            ) : row.riskLevel === 'Rendah' ? (
              <span className="badge badge-success text-black">Rendah</span>
            ) : row.riskLevel === 'Sedang' ? (
              <span
                className="badge text-black"
                style={{ backgroundColor: 'yellow' }}
              >
                Sedang
              </span>
            ) : row.riskLevel === 'Tinggi' ? (
              <span
                className="badge text-black"
                style={{ backgroundColor: 'orange' }}
              >
                Tinggi
              </span>
            ) : row.riskLevel === 'Sangat Tinggi' ? (
              <span className="badge badge-danger text-black">
                Sangat Tinggi
              </span>
            ) : (
              ''
            )}
          </div>
        </>
      ),
    },
    {
      name: 'Trend (Naik/Turun)',
      minWidth: '300px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={{
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              textAlign: 'center',
              width: '100%',
            }}
          >
            {/* {row?.riskStatusTrend} */}
            {row.riskStatusTrend === 'Tingkat risiko mengalami penurunan' ? (
              <span className="badge badge-success text-white">
                Tingkat risiko mengalami penurunan{' '}
                <IconArrowDown
                  stroke={2}
                  style={{ width: '15px', height: '15px' }}
                />
              </span>
            ) : row.riskStatusTrend ===
              'Tingkat risiko mengalami peningkatan' ? (
              <span className="badge badge-danger text-white">
                Tingkat risiko mengalami peningkatan{' '}
                <IconArrowUp
                  stroke={2}
                  style={{ width: '15px', height: '15px' }}
                />
              </span>
            ) : row.riskStatusTrend === 'Tidak ada penurunan tingkat risiko' ? (
              <span className="badge badge-info text-white">
                Tidak ada penurunan tingkat risiko{' '}
                <IconEqual
                  stroke={2}
                  style={{ width: '15px', height: '15px' }}
                />
              </span>
            ) : (
              ''
            )}
          </div>
        </>
      ),
    },
    {
      name: 'Tingkat Efektivitas',
      minWidth: '200px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={{
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              textAlign: 'center',
              width: '100%',
            }}
          >
            {/* {row?.isEffective} */}
            {row.isEffective === 'Efektif' ? (
              <span className="badge badge-primary text-white">Efektif</span>
            ) : row.isEffective === 'Tidak Efektif' ? (
              <span className="badge badge-info text-white">Tidak Efektif</span>
            ) : (
              ''
            )}
          </div>
        </>
      ),
    },
    {
      name: 'Penanggung Jawab Pemantauan',
      minWidth: '250px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={{
              whiteSpace: 'normal',
              textAlign: 'center',
              wordWrap: 'break-word',
              width: '100%',
            }}
          >
            {row?.pic}
          </div>
        </>
      ),
    },
  ];

  const customStyles = {
    rows: {
      style: {
        borderBottom: '1px solid #ddd', // Garis bawah pada setiap baris
      },
    },
    headCells: {
      style: {
        borderBottom: '2px solid #ccc', // Garis bawah yang lebih tebal pada header
        backgroundColor: '#dc3545', // Warna latar belakang header
        fontWeight: 'bold', // Membuat teks header lebih tegas
        textAlign: 'center', // Membuat thead ke tengah
        justifyContent: 'center', // Pusatkan konten secara horizontal
        color: '#FFFF',
      },
    },
    cells: {
      style: {
        borderRight: '1px solid #ddd', // Garis pemisah antar kolom
        padding: '10px', // Padding agar lebih rapi
      },
    },
  };

  return (
    <>
      <div style={{ overflowX: 'auto', maxWidth: '1200px' }}>
        <DataTable
          columns={columns}
          data={props?.listRiskManagementMonitoringReport}
          customStyles={customStyles}
          pagination
          fixedHeader
          highlightOnHover
          subHeader
          subHeaderComponent={
            <input
              type="text"
              placeholder="Cari Laporan Pemantauan"
              className="w-50 form-control m-3"
              values={props.searchReport}
              onChange={(e) => {
                // Hanya izinkan huruf, angka, dan spasi
                const cleanValue = e.target.value.replace(/[^a-zA-Z0-9\s]/g, "");
                props.handleChangeSearch(cleanValue);
              }}
            />
          }
          subHeaderAlign="center"
        />
      </div>
    </>
  );
};

export default DatatableRiskManagementMonitoringReport;
